import { render } from "./SportHeader.vue?vue&type=template&id=5784d65a&scoped=true"
import script from "./SportHeader.vue?vue&type=script&lang=js"
export * from "./SportHeader.vue?vue&type=script&lang=js"

import "./SportHeader.vue?vue&type=style&index=0&id=5784d65a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5784d65a"]])

export default __exports__